import React, { memo } from "react";
import { Input } from "reactstrap";

import { PointerTaxonomyEntry } from "../../types";
import { InputComponentProps } from "./common";

const PointerInputComponent = ({
  dataPoint,
  id,
  onFocus,
  onUpdate,
  value,
}: InputComponentProps<PointerTaxonomyEntry, string>) => {
  const invalid = dataPoint.required && value.idRef === null;
  const valid = value.idRef !== null;
  return (
    <div className="d-flex align-items-center">
      {value.value && <i className="fa fa-angle-double-left mr-2 text-muted" />}
      <Input
        autoComplete="off"
        className="text-truncate"
        id={id}
        invalid={invalid}
        onChange={e => {
          onUpdate(id, e.target.value, e.target.value);
        }}
        onFocus={() => {
          onFocus(id);
        }}
        placeholder="(Select a reference)"
        plaintext
        readOnly
        valid={valid}
        value={value.value}
      />
      {value.value && <i className="fa fa-angle-double-right ml-2 text-muted" />}
    </div>
  );
};
PointerInputComponent.displayName = "PointerInput";
export const PointerInput = memo(PointerInputComponent);
